var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.type,{tag:"component",staticClass:"border-solid rotate-45 block",style:({
    'transform': 'rotate(45deg)',
    'width': _vm.px(_vm.width),
    'height': _vm.px(_vm.height),
    'border-right-width': _vm.px(_vm.weight),
    'border-bottom-width': _vm.px(_vm.weight),
    'border-color': _vm.color
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }